"use client";

import useTranslate from "@app/_hooks/useTranslate";
import { useCartItemContext } from "./CartItem.context";

const CartItemRemove = () => {
  const t = useTranslate();
  const { item, removeItem } = useCartItemContext();

  if (!item) return null;

  return (
    <button
      type="button"
      className="absolute top-1 right-1 bg-transparent p-2 text-sm text-gray-300 underline hover:text-black"
      onClick={() => removeItem(item)}
    >
      {t("remove") ?? "Remove"}
    </button>
  );
};

CartItemRemove.displayName = "CartItemRemove";

export default CartItemRemove;
